<template>
  <div class="center_box">
    <Header style="margin-top:30px;"></Header>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        <router-link to="/">{{$t('message.homepage')}}</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.product')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.Selectionofparameters')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div><h1 style="font-size:34px;padding-top:20px;padding-bottom:20px;">{{$t('message.Selectionofparameters')}}</h1></div>
    <SelectedMotor v-on:listenPageChange="listenPageChange" v-on:listenParam="listenParam" v-show="MotorPage"></SelectedMotor>
    <SelectedCompleted ref="SelectedCompleted" v-on:listenPageChange="listenPageChange" v-show="CompletedPage" :param="param"></SelectedCompleted>
    <BackTop></BackTop>
  </div>
</template>
<script>
import BackTop from '../BackTop'
import SelectedMotor from './SelectedMotor'
import SelectedCompleted from './SelectedCompleted'
import Header from '../Header'
export default {
  name: 'MotorSelection',
  components: {
    SelectedMotor,
    SelectedCompleted,
    BackTop,
    Header
  },
  data () {
    return {
      MotorPage:true,
      CompletedPage:false,
      param:{}
    }
  },
  methods:{
    listenPageChange:function(data){
      if(data === 'to_MotorPage'){
        this.MotorPage = true;
        this.CompletedPage = false;
      }else if(data === 'to_CompletedPage'){
        //执行子组件方法
        this.$refs.SelectedCompleted._getinfobyreducersize(this.param);
        this.MotorPage = false;
        this.CompletedPage = true;
      }
    },
    listenParam:function(data){
      this.param.reducer_type = data.reducer_size
      this.param.reduction_ratio = data.reduction_ratio
      this.param.specifications = data.specifications
      // this.param.level = data.level
      this.param.motor_formula = data.motor_formula
      this.param.is_with_key = data.is_with_key
      this.param.reducer_series_name = data.reducer_series_name
    }
  }
}
</script>
<style scoped>
  .center_box {
    width:75%;
    margin:0 auto;
    height:100%;
  }
  .el-breadcrumb {
    font-size: 18px;
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/MotorSelection/MotorSelection.vue